import styled from 'styled-components';
import MenuItem from '../MenuItem';

const SignOut = styled(MenuItem)`
  margin-top: auto;
  margin-bottom: 14px;
`;

export default SignOut;
